import React, { Component } from "react";
import axios from "axios";
import { Button, Modal } from "react-bootstrap";
import { AgGridReact as AgGridReactPhone } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { getHeadersGSPS } from "../../../utility/utility";
import { AiTwotoneEdit as AiTwotoneEditPN } from "react-icons/ai";
import { IconContext as IconContextPN } from "react-icons";

class PhoneBlock extends Component {
  state = {
    phoneNumber: "",
    showPhoneBlockConfirm: false,
    columns: [
      {
        headerName: "Action",
        field: "value",
        cellRendererFramework: (params) => {
          return (
            <div
              className="cursor-pointer text-center"
              onClick={() =>this.state.accessFlagPhoneBlock && this.handleEditPhoneBlock(params)}
            >
              <IconContextPN.Provider
                value={{ color: this.state.accessFlagPhoneBlock?"#FDD017":'#cec9b4', size: "20px" }}
              >
                <AiTwotoneEditPN />
              </IconContextPN.Provider>
            </div>
          );
        },
        sortable: false,
        filter: false,
        floatingFilter: false,
        width: "80px",
      },
      {
        field: "phoneNumber",
        headerName: "Phone Number",
        width: "880px",
      },
    ],
    rows: null,
    enableBtn: false,
    gridApi: null,
    paginationValPhone: "25",
    defaultColumnDef: {
      resizable: true,
      // flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
    submitStatusPhoneBlock: null,
    submitMsgPhoneBlock: "",
    paginationOptionPhoneBlock: [25, 50, 100, 500],
    overlayLoadingTemplatePhone:
      '<span class="ag-overlay-loading-center">Loading...</span>',
    overlayNoRowsTemplatePhone: '<span style="">No Records Found</span>',
  };

  onChangeControlPhoneBlock = (e) => {
    this.setState({
      [e.target.name]: e.target.value.replace(/[^\d]/, ""),
    });
  };

  onChangeControlDropDownPhoneBlock = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onGridReadyPhoneBlock = (params) => {
    let accessFlagPhoneBlock = this.props.accessRole.includes(process.env.REACT_APP_DB_VIEW_SUPERUSER_READWRITE_ACCESS) || this.props.accessRole.includes(process.env.REACT_APP_DB_VIEW_GSP_READWRITE);
    this.setState({accessFlagPhoneBlock});
    if (params) {
      this.setState({ gridApi: params.api });
    }
    axios
      .get(
        `${process.env.REACT_APP_DB_VIEW_BASE_GSPSYS_SERVICE_URL}/v1/dbv/gspsys/phoneblock/getallphoneblockdetails`,
        {headers: {
          ...getHeadersGSPS().headers,
          Authorization: this.props.jwtToken? this.props.jwtToken: "",
        }}
      )
      .then((response) => {
        let recPhone = [];
        if (response.data.records !== null) {
          recPhone = response.data.records;
        }
        this.setState({
          rows: recPhone,
        });
      });
  };

  handleEditPhoneBlock = (params) => {
    let data = params.node.data;
    this.setState({
      phoneNumber: data.phoneNumber,
      enableBtn: true,
    });
  };

  onPageSizeChangedPhoneBlock = (e) => {
    this.setState({ paginationValPhone: e.target.value });
    this.state.gridApi.paginationSetPageSize(Number(e.target.value));
  };

  onHandleBackPhoneBlock = () => {
    this.props.history.push("/");
  };

  onValidatePhoneBlock = () => {
    if (this.state.phoneNumber === "") {
      this.setState({
        submitStatusPhoneBlock: "Error",
        submitMsgPhoneBlock: "Please Enter The Value For Phone Number ",
      });
      return false;
    }
    return true;
  };
  onHandleAddPhoneBlock = () => {
    if (!this.onValidatePhoneBlock()) {
      return;
    }
    let submittedObj = {};
    submittedObj.phoneNumber = this.state.phoneNumber;
    axios
      .post(
        `${process.env.REACT_APP_DB_VIEW_BASE_GSPSYS_SERVICE_URL}/v1/dbv/gspsys/phoneblock/addphoneblockdata`,
        submittedObj,
        {headers: {
          ...getHeadersGSPS().headers,
          Authorization: this.props.jwtToken? this.props.jwtToken: "",
        }}
      )
      .then((response) => {
        if (response.status === 200 && response.data.responseString==='Record Added Successfully') {
          submittedObj.phoneNumber = this.state.phoneNumber;
          this.setState({
            submitStatusPhoneBlock: "OK",
            submitMsgPhoneBlock: response.data.responseString,
            rows: [submittedObj, ...this.state.rows],
          });
          this.onHandleClearPhoneBlock();
        } else {
          this.setState({
            submitStatusPhoneBlock: "Error",
            submitMsgPhoneBlock: response.data.responseString,
          });
          this.onHandleClearPhoneBlock();
        }
      });
  };

  onHandleClearPhoneBlock = () => {
    this.setState({
      phoneNumber: "",
      enableBtn: false,
    });
    setTimeout(
      () =>
        this.setState({
          submitStatusPhoneBlock: null,
        }),
      5000
    );
  };

  getPhoneBlockModal = () => {
    return (
      <div>
        <Modal
          show={this.state.showPhoneBlockConfirm}
          animation={true}
          size="md"
          className="shadow-lg border"
        >
          <Modal.Header className="bg-dark text-white text-center py-1">
            <Modal.Title className="text-center">
              <h5 className="modal-header-custom">
              Are You Sure, You Want To Delete The Phone {this.state.phoneNumber} ?
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Footer className="py-1 d-flex justify-content-center">
            <div>
              <Button
                variant="warning"
                onClick={() => this.setState({ showPhoneBlockConfirm: false })}
                data-test="button-no"
              >
                No
              </Button>
            </div>
            <div>
              <Button
                variant="warning"
                className="mx-2 px-3"
                onClick={this.onHandleDeletePhoneBlock}
                data-test="button-yes"
              >
                Yes
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  };

  onHandleDeletePhoneBlock = () => {
    let submittedObj = {};
    submittedObj.phoneNumber = this.state.phoneNumber;
    axios
      .put(
        `${process.env.REACT_APP_DB_VIEW_BASE_GSPSYS_SERVICE_URL}/v1/dbv/gspsys/phoneblock/deletephoneblockdata`,
        submittedObj,
        {headers: {
          ...getHeadersGSPS().headers,
          Authorization: this.props.jwtToken? this.props.jwtToken: "",
        }}
      )
      .then((response) => {
        if (response.status === 200) {
          let newRows = this.state.rows.filter((row) => {
            return row.phoneNumber !== submittedObj.phoneNumber;
          });

          this.setState({
            submitStatusPhoneBlock: "OK",
            submitMsgPhoneBlock: response.data.responseString,
            rows: newRows,
          });
          this.onHandleClearPhoneBlock();
        } else {
          this.setState({
            submitStatusPhoneBlock: "Error",
            submitMsgPhoneBlock: response.data.responseString,
          });
          this.onHandleClearPhoneBlock();
        }
      });
    this.setState({ showPhoneBlockConfirm: false });
  };

  render() {
    return (
      <div className="container-fluid padding-left0">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title main-heading">PHONE BLOCK</h4>
            <div className="card ">
              <div className="card-header bg-dark text-white card-header-custom">
                Block Phone Number
              </div>
              <div className="card-body card-body-custom">
                <form>
                  <div className="form-group row">
                    <div className="col-lg">
                      <label htmlFor="phoneNumber" className="font-weight-bold">Phone Number</label>
                      <input
                        type="text"
                        maxLength="10"
                        size="10"
                        value={this.state.phoneNumber}
                        className="form-control form-control-sm"
                        name="phoneNumber"
                        onChange={(e) => {
                          this.onChangeControlPhoneBlock(e);
                        }}
                        data-test="text-phoneNumber"
                        placeholder="Phone Number"
                        disabled={this.state.enableBtn}
                      />
                    </div>
                  </div>
                  <div className="form-group row margin-0">
                    <div className="col-lg-3"></div>
                    <div className="col-lg-6 text-center mar-bottom5">
                      <button
                        type="button"
                        className="btn btn-warning mar-right10"
                        onClick={this.onHandleBackPhoneBlock}
                        data-test="button-back"
                      >
                        GSP SYS
                      </button>
                      <button
                        type="button"
                        className="btn btn-warning mar-right10"
                        disabled={this.state.enableBtn || !this.state.accessFlagPhoneBlock}
                        onClick={this.onHandleAddPhoneBlock}
                        data-test="button-add"
                      >
                        ADD
                      </button>
                      <button
                        type="button"
                        className="btn btn-warning mar-right10"
                        onClick={this.onHandleClearPhoneBlock}
                        disabled={!this.state.enableBtn}
                      >
                        CLEAR
                      </button>
                      <button
                        type="button"
                        className="btn btn-warning"
                        onClick={() => {
                          this.setState({ showPhoneBlockConfirm: true });
                        }}
                        data-test="button-delete"
                        disabled={!this.state.enableBtn}
                      >
                        DELETE
                      </button>
                      <div className="row mar-top10">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-8">
                        {this.state.submitStatusPhoneBlock === "OK" && (
                          <div className="alert alert-success alert-padding notification">
                            {this.state.submitMsgPhoneBlock}
                          </div>
                        )}
                        {this.state.submitStatusPhoneBlock === "Error" && (
                          <div className="alert alert-danger alert-padding notification">
                            {this.state.submitMsgPhoneBlock}
                          </div>
                        )}
                        </div>
                        <div className="col-lg-2"></div>
                      </div>
                    </div>
                    <div className="col-lg-3"></div>
                  </div>
                </form>
              </div>
            </div>
            {this.getPhoneBlockModal()}
            <div className="card mar-top20">
              <div className="card-header bg-dark text-white card-header-custom">
                Blocked Phone Number
              </div>
              <div className="card-body card-body-custom">
                <div className="pagination-dropdown">
                  <label htmlFor="pagination-select-label" className="font-weight-bold">
                    No of records per page
                  </label>
                  <select
                    className="form-control form-control-sm"
                    onChange={(e) => {
                      this.onChangeControlDropDownPhoneBlock(e);
                      this.onPageSizeChangedPhoneBlock(e);
                    }}
                    value={this.state.paginationValPhone}
                    name="paginationDropdownPhone"
                    data-test="select-dropdown"
                  >
                    {this.state.paginationOptionPhoneBlock.map((val) => {
                      return (
                        <option key={val} value={val}>
                          {val}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div
                  className="ag-theme-balham"
                  style={{ height: 250, width: "100%" }}
                >
                  <AgGridReactPhone
                    rowData={this.state.rows}
                    columnDefs={this.state.columns}
                    defaultColDef={this.state.defaultColumnDef}
                    pagination={true}
                    paginationPageSize={25}
                    onGridReady={this.onGridReadyPhoneBlock}
                    data-test="component-grid"
                    enableCellTextSelection={true}
                    overlayLoadingTemplate={
                      this.state.overlayLoadingTemplatePhone
                    }
                    overlayNoRowsTemplate={
                      this.state.overlayNoRowsTemplatePhone
                    }
                  ></AgGridReactPhone>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PhoneBlock;
